import React, { createContext, useContext, useEffect, useState } from 'react';
import ModalTask from 'components/Organisms/Modals/ModalTask/ModalTask';
import iconCortPng from 'assets/images/home.png';
import Step1 from './Step1/Step1';
import { Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  Entity,
  Task,
  TaskResponse,
  TaskState
} from '../../../../../gql/graphql';
import { useGetTaskResponsesByTask } from '../../../../../services/task/querys';
import StateTag from 'components/Atoms/Tags/StateTag/StateTag';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { findTaskRules } from '../../RulesTaskCards.constanst';
import { TaskOpenModalContext } from '../../../Private';
import CircleTag from '../../../../../components/Atoms/Tags/CircleTag/CircleTag';

export const TaskContext = createContext<Task | {}>({});
export const EntityContext = createContext<Entity | {}>({});

interface Props {
  task: Task;
}

const Purchase = ({ task }: Props) => {
  const { value: openContext, setHandler }: any = useContext(TaskOpenModalContext);

  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [isReview, setIsReview] = useState(false);
  const [step, setStep] = useState(1);
  const [responseStep1, setResponseStep1] = useState<TaskResponse>();
  const [entity, setEntity] = useState<Entity | any>();

  useEffect(() => {
    if (openContext === 'purchase') {
      setModalTaskVisible(true);
      setHandler();
    } else if (!!openContext)
      setModalTaskVisible(false);
  }, [openContext]);

  useEffect(() => {
    if (isModalTaskVisible)
      getTaskResponses({ requestPolicy: 'network-only' });
  }, [isModalTaskVisible])

  useEffect(() => {
    const step1: any = taskResponses?.find((item) => item.step === 1);
    setResponseStep1(step1);
    setIsReview(task.state === TaskState.Review);
  }, [taskResponses]);

  const onHelpDocs = () => {
    console.log('onHelpDocs');
  };

  const circlesOtherDocs: any = () => {
    const addAnotherDocs = task.responses?.filter(item => item.key === 'doc-another');

    const docs = addAnotherDocs?.map(item =>
      ({ state: item.state, name: item.label })
    ) || [];
    return docs;
  };

  const getTotalApproved = () =>
      task?.responses?.filter((item: any) => item.state !== TaskState.Draft && item.state !== TaskState.RequestError)?.length;

  const renderTracker = () => (
    <div style={{ height: '100%' }}>
      <span className='title-summary'>Task summary</span>
      <div className="mt-20">
        <div className="owners-tags">
          <p className="placeholder" style={{ marginTop: 15, fontWeight: 500 }}>
            Signed purchase agreement
          </p>

          <p
            className="placeholder"
            style={{ marginTop: 55, fontWeight: 500 }}
          >
            Document status{' '}
          </p>
          <div className="owners-tags mt-10">
            <span>
              {getTotalApproved() || 0}
              /{circlesOtherDocs().length > 0 ? 1+circlesOtherDocs().length : 1} documents submitted</span>
          </div>

          <div className="mt-10 circles-tags">
            <CircleTag
              state={responseStep1?.state || 'DRAFT'}
              tagKey={'lala'}
            />
          {circlesOtherDocs().map((item: any, index: number) => {
            return (
              <CircleTag
                key={index}
                state={item.state}
                tagKey={item.state}
              />
            )
          })}
          </div>
        </div>
      </div>
    </div>
  );

  const { taskName } = findTaskRules(ModuleKeys.PURCHASE);
  
  return (
    <TaskContext.Provider value={task}>
      <EntityContext.Provider value={entity}>
        <ModalTask
          visible={isModalTaskVisible}
          handlerSetVisibile={setModalTaskVisible}
          isConfirmModalClose={task.state !== TaskState.Approved && !isReview}
          responses={taskResponses}
          renderButtonTrigger={(openModal: any) => (
            <Button
              className={`button-open-modal button-open-modal-${task.state}`}
              onClick={() => openModal(true)}
            >
              {(task.state === TaskState.Review || task.state === TaskState.Approved) ? 'View task' :
                (task.state === TaskState.Incomplete) ? 'Complete task' :
                (task.state === TaskState.RequestError) ? 'Resolve issues' :
                  'Begin Task'
              }
            </Button>
          )}
          header={{
            title: <span>{taskName.toUpperCase()}</span>,
            actionLeft: (
              isReview ? <StateTag state={TaskState.Review} size="large" /> : <img src={iconCortPng} alt="icon" className="paperPng" />
            ),
            actionRight: (
              <Button
                className="button button-transparent"
                onClick={() => onHelpDocs()}
              >
                <QuestionCircleOutlined />
                Help docs
              </Button>
            )
          }}
          animationDirection="onRight"
          stepsTotal={1}
          currentStep={step}
          setStep={setStep}
          tracker={renderTracker()}
        >
          <section className="children AchPaymentForm">
            {step === 1 && (
              <Step1
                setStep={setStep}
                closeTask={() => setModalTaskVisible(false)}
              />
            )}
          </section>
        </ModalTask>
      </EntityContext.Provider>
    </TaskContext.Provider>
  );
};
export default Purchase;